import {BBModel} from "../bb_model";

const space = {
    query(company) {
        return new Promise((resolve, reject) => {
            if (!company.$has('spaces')) {
                reject('No spaces found');
            } else {
                company.$get('spaces').then((resource) => {
                        return resource.$get('spaces').then((items) => {
                                const spaces = [];
                                for (const i of Array.from(items)) {
                                    spaces.push(new BBModel.Space(i));
                                }
                                return resolve(spaces);
                            }
                        );
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            }
        });
    }
};

export {
    space
}